import styled, { css } from 'styled-components';
import { StyledColumnProps, columnStyles } from '../Column.styles';
import { cssVar, mediaQuery } from 'src/app/styles/helper';
import { StyledSpacingProps, spacingStyles } from '../Spacing.styles';
import { StyledMaxWidthProps, maxWidthStyles } from '../MaxWidth.styles';
import { StyledVisibilityProps, visibilityStyles } from '../Visibility.styles';
import { ColorModePropKeys } from 'src/app/styles/colors';
import { borderStyles } from '../Border.styles';

interface GridProps extends StyledColumnProps, StyledSpacingProps, StyledMaxWidthProps, StyledVisibilityProps {
  $totalColumns?: number;
  $totalColumnsSm?: number;
  $totalColumnsMd?: number;
  $totalColumnsLg?: number;
  $totalColumnsXl?: number;
  $totalColumns2xl?: number;
  $totalChildren?: number;
  $position?: 'static' | 'relative' | 'absolute' | 'fixed' | 'sticky';
  $background?: ColorModePropKeys;
}

const getGridTemplateColumns = (totalColumns: number, totalChildren?: number) => css`
  --grid-total-columns: ${totalColumns};
  --grid-total-children: ${totalChildren};
  grid-template-columns: repeat(${totalColumns}, 1fr);
`;

export const GridContainer = styled.div<GridProps>`
  /* Used on hide/show helpers */
  --layout-display-property: grid;

  display: var(--layout-display-property);
  width: 100%;

  ${({ $position }) => $position && `position: ${$position};`}
  ${({ $background }) => $background && `background: ${cssVar($background)};`}
  ${({ $totalColumns = 12, $totalChildren }) => getGridTemplateColumns($totalColumns, $totalChildren)}

  ${({ $totalColumns2xl, $totalChildren }) => {
    if (!$totalColumns2xl) return '';
    return mediaQuery('2xl', getGridTemplateColumns($totalColumns2xl, $totalChildren));
  }}

  ${({ $totalColumnsXl, $totalChildren }) => {
    if (!$totalColumnsXl) return '';
    return mediaQuery('xl', getGridTemplateColumns($totalColumnsXl, $totalChildren));
  }}

  ${({ $totalColumnsLg, $totalChildren }) => {
    if (!$totalColumnsLg) return '';
    return mediaQuery('lg', getGridTemplateColumns($totalColumnsLg, $totalChildren));
  }}

  ${({ $totalColumnsMd, $totalChildren }) => {
    if (!$totalColumnsMd) return '';
    return mediaQuery('md', getGridTemplateColumns($totalColumnsMd, $totalChildren));
  }}

  ${({ $totalColumnsSm, $totalChildren }) => {
    if (!$totalColumnsSm) return '';
    return mediaQuery('sm', getGridTemplateColumns($totalColumnsSm, $totalChildren));
  }}

  ${borderStyles}
  ${columnStyles}
  ${spacingStyles}
  ${maxWidthStyles}
  ${visibilityStyles}
`;
